export default __webpack_public_path__ + "static/media/2-lighthouse.90f725bd.png";